import React, { useEffect, useRef, useState } from 'react';
import RsDatePicker from 'rsuite/DatePicker';
import { format } from 'date-fns';
import 'rsuite/dist/rsuite-no-reset.min.css';
import { FormControl, Button, FormLabel, FormHelperText, FormErrorMessage } from '@chakra-ui/react';
import Typography from './Typography.js';
import DatePickerStyles from './DatePicker.css.js';
import { getCurrentLanguage, getDirection } from '../utils/i18n.js';
import Calendar from '../icons/Calendar.js';
import Question from '../icons/Question.js';
import CloseFilled from '../icons/CloseFilled.js';

var DatePicker = function (props) {
    var onDateValueChange = props.onDateValueChange, size = props.size, isRequired = props.isRequired, isInvalid = props.isInvalid, id = props.id, error = props.error, helpText = props.helpText, _a = props.name, name = _a === void 0 ? "DD/MM/YYYY" : _a, shouldDisableDate = props.shouldDisableDate, showLabel = props.showLabel, defaultDate = props.defaultDate, value = props.value, dir = props.dir, _b = props.placement, placement = _b === void 0 ? "bottomStart" : _b, _c = props.width, width = _c === void 0 ? "100%" : _c;
    var currentLanguage = getCurrentLanguage();
    var direction = dir !== null && dir !== void 0 ? dir : getDirection(currentLanguage);
    useEffect(function () {
        var applyDirectionToPopup = function () {
            var popupElement = document.querySelector(".rs-picker-popup-date");
            if (popupElement) {
                popupElement.style.setProperty("direction", direction);
            }
        };
        applyDirectionToPopup();
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === "childList") {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            var element = node;
                            if (element.classList.contains("rs-picker-popup-date")) {
                                element.style.setProperty("direction", direction);
                            }
                        }
                    });
                }
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        return function () {
            observer.disconnect();
        };
    }, [direction, id]);
    var datePickerRef = useRef(null);
    var _d = useState(value), selectedDate = _d[0], setSelectedDate = _d[1];
    var _e = useState(value || null), tempDate = _e[0], setTempDate = _e[1];
    var _f = useState(false), focus = _f[0], setFocus = _f[1];
    useEffect(function () {
        setSelectedDate(value);
        setTempDate(value || null);
    }, [value]);
    var handleOpen = function () {
        var _a;
        if ((_a = datePickerRef.current) === null || _a === void 0 ? void 0 : _a.open)
            datePickerRef.current.open();
    };
    var handleOk = function () {
        var _a;
        if (tempDate) {
            setSelectedDate(tempDate);
            onDateValueChange(tempDate);
        }
        if ((_a = datePickerRef.current) === null || _a === void 0 ? void 0 : _a.close)
            datePickerRef.current.close();
    };
    var formattedDate = selectedDate
        ? format(selectedDate, "dd/MM/yyyy")
        : "DD/MM/YYYY";
    return (React.createElement(FormControl, { id: id, variant: "floating", isRequired: isRequired !== null && isRequired !== void 0 ? isRequired : false, style: { zIndex: 10 }, isInvalid: isInvalid !== null && isInvalid !== void 0 ? isInvalid : false },
        React.createElement(Button, { onClick: handleOpen, variant: "outline", width: width, height: size === "sm" ? "36px" : "48px", borderRadius: "6px", leftIcon: React.createElement(Calendar, null), borderColor: isInvalid ? "red.500" : undefined, _active: { backgroundColor: "white" }, dir: direction }, formattedDate),
        React.createElement(RsDatePicker, { ref: datePickerRef, block: true, id: "date-picker-".concat(id), dir: direction, onFocus: function () {
                setFocus(true);
            }, onBlur: function () {
                setFocus(false);
            }, defaultValue: defaultDate || null, value: tempDate, shouldDisableDate: shouldDisableDate, format: "dd/MM/yyyy", placeholder: name, onSelect: function (value) {
                setTempDate(value);
            }, onOk: handleOk, size: size, onClean: function () {
                setSelectedDate(undefined);
                setTempDate(null);
            }, placement: placement }),
        showLabel && (React.createElement(FormLabel, { className: "label", style: {
                transform: "".concat(selectedDate || focus
                    ? "scale(0.85) translateY(".concat(size === "sm" ? "-16px" : "-24px", ")")
                    : ""),
                top: "-3px",
                marginLeft: !focus && size === "sm" ? "8px" : "12px",
            }, sx: {
                display: "flex",
                alignItems: "center",
                height: size === "sm" ? 5 : 8,
            } }, name)),
        !isInvalid && helpText && (React.createElement(FormHelperText, { display: "flex", gap: 1, justifyContent: "flex-start", alignItems: "center" },
            React.createElement(Question, { w: 3, h: 3 }),
            " ",
            React.createElement(Typography, { color: "neutrals.600", variant: "small" }, helpText))),
        isInvalid && (React.createElement(FormErrorMessage, { display: "flex", gap: 1 },
            React.createElement(CloseFilled, { w: 3, h: 3 }),
            " ",
            React.createElement(Typography, { variant: "small", color: "error.700" },
                error,
                " "),
            " ")),
        React.createElement("style", null, DatePickerStyles.styles)));
};

export { DatePicker as default };
//# sourceMappingURL=DatePicker.js.map
